<template>
	<main id="container" class="page-container information bg-wave3">
		<div class="page-header">
			<div class="container">
				<div class="display-flex is-between">
					<page-header title="카드뉴스" />
				</div>
			</div>
		</div>
		<div class="page-content">
			<div class="container">
				<div class="info-content-img">
					<img src="@/assets/img/news/everyBody_0428.png" alt="카드뉴스" style="width: 100%; max-width: 1000px; margin: 20px auto; display: block;" />
					<img src="@/assets/img/news/everyBody_01.png" alt="카드뉴스 1" style="width: 100%; max-width: 1000px; margin: 20px auto; display: block;" />
					<img src="@/assets/img/news/everyBody_02.png" alt="카드뉴스 2" style="width: 100%; max-width: 1000px; margin: 20px auto; display: block;" />
					<img src="@/assets/img/news/everyBody_03.png" alt="카드뉴스 3" style="width: 100%; max-width: 1000px; margin: 20px auto; display: block;" />
					<img src="@/assets/img/news/everyBody_04.png" alt="카드뉴스 4" style="width: 100%; max-width: 1000px; margin: 20px auto; display: block;" />
				</div>
				<!-- <div class="information-period">
					<div class="period-desc">
						<span class="period-desc-title">행사기간</span>
						<span class="period-desc-date">2024년 12월 1일(일) ~ 12월 28일(토)</span>
					</div>
					<div class="period-icon">
						<img src="@/assets/img/information/info-calendar-icon.png" alt="" />
					</div>
				</div> -->
			</div>
		</div>
	</main>
</template>

<script>
import PageHeader from '@/components/content/PageHeader';
export default {
	name: 'NewsInfo2',
	components: { PageHeader },
	data: () => ({}),
	computed: {},
	watch: {},
	created() {},
	mounted() {},
	methods: {},
};
</script>
